// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__iXrZ-","loader":"style_loader__uv2Uq","rotate360":"style_rotate360__vvwCB","child":"style_child__KNQqj","rotate":"style_rotate__nolbU"};